import { Grid, Paper } from "@mui/material"
import { Title } from "components/Common/Title"
import { CreateLicensePoolDialog } from "components/LicensePool/CreateLicensePoolDialog"
import { LicensePoolList } from "components/LicensePool/LicensePoolList"
import { useAppDispatch, useAppSelector } from "hooks"
import { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import authService from "services/authService"
import organizationService from "services/organizationService"
import simulatorApplicationService from "services/simulatorApplicationService"
import { setCurrentOrganization } from "slices/organizationSlice"
import { setSimulatorApplications } from "slices/simulatorApplicationSlice"
import { UserRoles } from "types/userRoles"

export function OrganizationLicensePools() {
  const [roles, setRoles] = useState<Array<string>>()
  const { id } = useParams()
  const dispatch = useAppDispatch()

  const currentOrganization = useAppSelector((state) => state.organization.currentOrganization)

  const simulatorApplications = useAppSelector(
    (state) => state.simulatorapplication.simulatorApplications,
  )

  useEffect(() => {
    authService.getRolesAssignedToUser().then((r) => {
      setRoles(r)
      if (r?.includes(UserRoles.HIAB_ADMIN) && simulatorApplications.length < 1) {
        simulatorApplicationService
          .getSimulatorApplications()
          .then((simulators) => {
            dispatch(setSimulatorApplications(simulators))
          })
          .catch((err) => {
            console.error(err)
          })
      }
    })

    if (currentOrganization === undefined && id) {
      organizationService
        .getOrganization(id)
        .then((organization) => {
          dispatch(setCurrentOrganization(organization))
        })
        .catch((err) => {
          console.error(err)
        })
    }
  }, [currentOrganization, dispatch, id, simulatorApplications.length])

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Paper sx={{ p: 2, display: "flex", flexDirection: "column" }}>
          <Grid container paddingBottom={2}>
            <Grid item xs>
              <Title>LICENSE POOLS</Title>
            </Grid>
            <Grid item>
              {roles?.includes(UserRoles.HIAB_ADMIN) && currentOrganization && (
                <CreateLicensePoolDialog organization={currentOrganization} />
              )}
            </Grid>
          </Grid>
          {currentOrganization && <LicensePoolList organization={currentOrganization} />}
        </Paper>
      </Grid>
    </Grid>
  )
}
